export const showAuthorBlog = (pathname: string, authorId?: string) => (
  pathname.includes('blogs') && authorId
);
